export const consts = {
  Phone: -3,
  Email: -2,
  Mobile: -1
};
